import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/common.json';
import jaTranslation from './locales/ja/common.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    ja: { translation: jaTranslation }
  },
  lng: 'ja', // 初期言語
  fallbackLng: 'ja', // フォールバック言語
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
